export default __webpack_public_path__ + "static/media/equipment-placeholder.e2995120.svg";